"use client";

import { useSyncExternalStore } from "react";

// External store mirroring `isCanvasPositionInteracting` so subtree components
// (e.g. AnimatedEdge) can opt into a downgraded render path during drag without
// each subscribing to the ReactFlow store or a giant React Context.
//
// canvas-root publishes via `publishCanvasPositionInteracting`; consumers use
// `useIsCanvasPositionInteracting()`.

let dragging = false;
const listeners = new Set<() => void>();

function notify() {
  for (const fn of listeners) {
    try {
      fn();
    } catch {}
  }
}

export function publishCanvasPositionInteracting(value: boolean): void {
  const next = Boolean(value);
  if (next === dragging) return;
  dragging = next;
  notify();
}

function subscribe(cb: () => void): () => void {
  listeners.add(cb);
  return () => {
    listeners.delete(cb);
  };
}

function getSnapshot(): boolean {
  return dragging;
}

function getServerSnapshot(): boolean {
  return false;
}

export function useIsCanvasPositionInteracting(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}

export function getIsCanvasPositionInteractingSync(): boolean {
  return dragging;
}
